// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vsTk","content":"styles_content__3MYdf"};